import * as Utils from "../utils/Config";
import { AuthContextModel } from '../App'
import { ApiClient } from "./ApiClient";
import { IUserInfo } from "../models/IUserInfo";

export interface ClinicModel {
    id: string;
    organisationName: string;
    clinicName: string;
    organisationNumber: string;
    clinicNumber: string;
    roleGroupId: number;
    roles: string[];
    isDefault: boolean;
}

export class UserApi extends ApiClient {
    constructor(auth: AuthContextModel) {
        super(auth);
    }

    getClinics(applicationId: number, success: (data: ClinicModel[]) => void, error?: (message: string) => void, final?: () => void) {
        this.get<ClinicModel[]>(`${Utils.MEN_API_BASE_URL}/user/clinics/${applicationId}`, success, error, final);
    }

    getUser(applicationId: number, success: (data: IUserInfo) => void, error?: (message: string) => void, final?: () => void) {
        this.get<IUserInfo>(`${Utils.MEN_API_BASE_URL}/user/${applicationId}`, success, error, final);
    };

    setDefaultRole(roleGroupId: string, success: () => void, error?: (message: string) => void, final?: () => void) {
        this.post(`${Utils.MEN_API_BASE_URL}/user/defaultRole`, roleGroupId, success, error, final);
    };
}

